import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { twcn } from '@web/ui/core/utils';

/*
 * Spinner — inline progress indicator.
 *
 * Examples: <Spinner /> | <Spinner size="lg" />
 */
const spinnerVariants = cva(
  'inline-block animate-spin rounded-pill border-input border-t-muted-foreground',
  {
    variants: {
      size: {
        sm: 'h-3 w-3 border-hair',
        md: 'h-4 w-4 border-2',
        lg: 'h-6 w-6 border-2',
      },
    },
    defaultVariants: { size: 'sm' },
  },
);

export interface SpinnerProps
  extends HTMLAttributes<HTMLOutputElement>, VariantProps<typeof spinnerVariants> {}

export const Spinner = forwardRef<HTMLOutputElement, SpinnerProps>(function Spinner(
  { className, size, ...props },
  ref,
) {
  return (
    <output
      ref={ref}
      aria-label="Loading"
      className={twcn(spinnerVariants({ size }), className)}
      {...props}
    />
  );
});
